<!-- coordinate-dialog.component.html -->
<h1 mat-dialog-title class="display-6">Set {{ title }}</h1>
<mat-dialog-content style="padding-left: 20px; padding-right: 20px;">

  <div class="row" style="height: 112px; border: 1px solid; border-radius: 5px; padding: 5px;">
    <!-- Degrees Input -->
    <div class="col-4" style="padding-left: 0px; padding-right: 5px;">
      <div class="row">
        <mat-form-field hideRequiredMarker="true" style="font-size: x-large;">
          <mat-label>Degrees</mat-label>
          <input matInput
                 #deg
                 type="text"
                 inputmode="decimal"
                 [size]="latLonLen"
                 [maxlength]="latLonLen"
                 (input)="_handleInput(degrees, latLonLen, minInput)"
                 [formControl]="degrees" />
          <!-- Error Messages for Degrees -->
          <mat-error *ngIf="degrees.invalid && (degrees.dirty || degrees.touched)">
            <span *ngIf="degrees.hasError('max')">Out of range</span>
          </mat-error>
        </mat-form-field>
      </div>
    </div>

    <!-- Minutes Input -->
    <div class="col-4" style="padding-left: 0px; padding-right: 0px;">
      <div class="row">
        <mat-form-field hideRequiredMarker="true" style="padding-right: 15px; font-size: x-large;">
          <mat-label>Minutes</mat-label>
          <input matInput
                 #minInput
                 type="text"
                 inputmode="decimal"
                 size="2"
                 maxlength="2"
                 (input)="_handleInput(minutes, 2, decimalMinutesInput)"
                 [formControl]="minutes" />
          <!-- Error Messages for Minutes -->
          <mat-error *ngIf="minutes.invalid && (minutes.dirty || minutes.touched)">
            <span *ngIf="minutes.hasError('max')">Must be &lt;60</span>
          </mat-error>
        </mat-form-field>
      </div>
    </div>

    <!-- Decimal Point -->
    <div class="col-1"
         style="padding-left: 0px; padding-right: 0px; padding-top: 30px;">
      <span style="font-size: xx-large;">.</span>     
    </div>

    <!-- Decimal Minutes Input -->
    <div class="col-3" style="padding-left: 0px; padding-right: 0px;">
      <div class="row">
        <mat-form-field hideRequiredMarker="true" style="padding-left: 0px; font-size: x-large;">
          <mat-label></mat-label>
          <input matInput
                 #decimalMinutesInput
                 type="text"
                 inputmode="decimal"
                 size="2"
                 maxlength="2"
                 [formControl]="decimalMinutes"
                 (input)="_forbidNonNumeric(decimalMinutes)"
                 (keyup.enter)="onConfirm()" />          
                               
          <span matSuffix *ngIf="isGroundfish && latLonLen == 2" style="font-weight:bold; font-size: x-large;">N</span>
          <span matSuffix *ngIf="isGroundfish && latLonLen == 3" style="font-weight:bold; font-size: x-large;">W</span>

        </mat-form-field>
            
      </div>
    </div>


    
  </div>

  <!-- Hemisphere Selection -->
  <div *ngIf="fishery == 'HMS'" class="row" style="margin-top: 10px;">
    <mat-radio-group [formControl]="hemisphere">
      <mat-radio-button *ngIf="isLatitude" value="N">North</mat-radio-button>
      <mat-radio-button *ngIf="isLatitude" value="S">South</mat-radio-button>
      <mat-radio-button *ngIf="!isLatitude" value="E">East</mat-radio-button>
      <mat-radio-button *ngIf="!isLatitude" value="W">West</mat-radio-button>
    </mat-radio-group>
  </div>

  

</mat-dialog-content>

<mat-dialog-actions style="justify-content: space-around;">
  <button mat-stroked-button
          class="text-blue-button"
          type="button"
          (click)="dialogRef.close()">
    Cancel
  </button>
  <button mat-stroked-button
          class="color-button-orange"
          type="button"
          (click)="onClear()">
    Clear
  </button>
  <button mat-stroked-button
          class="text-button"
          type="submit"
          (click)="onConfirm()">
    OK
  </button>
</mat-dialog-actions>
